import { useEffect } from "react";
import { toast } from "react-toastify";

import { useQuery } from "@tanstack/react-query";

import { useAuth } from "../../../utils/context/Auth/AuthContext.tsx";
import useFetch from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

import { IClientResponse } from "./type.ts";

type useClientsParams = {
  quickSearch: string;
  page: number;
  pageSize: number;
};

export const useClients = (params: useClientsParams) => {
  const { token } = useAuth();
  const { pageSize, page, quickSearch } = params;

  const fetch = useFetch();

  const { data, isFetching, isError, error } = useQuery<
    IClientResponse | null,
    Error,
    IClientResponse
  >({
    queryKey: ["clients", quickSearch, pageSize, page],
    enabled: !!(pageSize && page && quickSearch.length > 2),
    queryFn: () =>
      fetch<IClientResponse>(`${Urls.Clients}?page=${page}&pageSize=${pageSize}&${quickSearch ? `quickSearch=${quickSearch}&` : ""}`, {
        method: "GET",
      }, true, token),
    // gcTime: 0,
    // staleTime: 0,
  });

  useEffect(() => {
    if (isError) {
      toast.error(error?.message || "Error getting clients");
    }
  }, [error?.message, isError]);

  return {
    data,
    isFetching,
  };
};
